export interface InstanceConfig {
  name: string;
  tier: "portal";
  brand: string;
  logoSrc?: string;
  /** Enabled module keys; omit or empty = all modules. */
  modules?: string[];
  /** Rail: one flyout per group (default) or flat module icons. */
  navigation?: "groups" | "items";
  /** Retune group hues (group key -> CSS colour), e.g. a customer's palette. */
  tones?: Record<string, string>;
}

const profiles = import.meta.glob("../instances/*/config.ts", {
  eager: true,
  import: "default",
}) as Record<string, InstanceConfig>;

const name = import.meta.env.VITE_INSTANCE || "ops";
export const instance = profiles[`../instances/${name}/config.ts`] ?? profiles["../instances/ops/config.ts"];

if (!instance) throw new Error(`No compliance instance profile for ${name}`);
